import OTP from "./orb-otp";

export default OTP